import React from "react"
import Link from "next/link"

import {
  Card,
  Button,
  Col,
  Nav
} from "react-bootstrap"

import * as Scroll from "react-scroll"
import Image from "./CustomImage"
import Icon from "./Icon"
import constants from "../lib/constants"


const CardVendor = (props) => {
  const { code, verified, company, contact, locations } = props.data
  const { sidebarMenu } = props
  const { location_city = '', location_country = '' } = locations[0] ? locations[0] : {};
  const location = `${location_city}, ${location_country.label}`
  const ScrollLink = Scroll.Link

  const scrollLinkProps = {
    offset: -100,
    spy: true,
    smooth: true,
    activeClass: "active",
    className: "nav-link subtitle text-sm",
    href: "#",
  }

  return (
    <Card
      style={{ top: "100px" }}
      //className="border-0 shadow mb-6 mb-lg-0"
      // className="p-4 shadow ms-lg-4 rounded sticky-top"
      className="border-0 shadow mb-6 mb-lg-0 sticky-top"
    >
      <Card.Header className="bg-gray-100 py-4 border-0 text-center">
        <a href="#" className="d-inline-block">
          <div className="avatar avatar-xxl p-2 mb-2">
            <div className="position-relative h-100 overflow-hidden rounded-circle">
              {company.company_logo_url[0] ? (
                <Image src={`${constants.LOGO_URL}/${company.company_logo_url[0].name}`}
                  width={144}
                  height={144}
                  layout="fixed"
                  alt="user picture"
                /*                   style={{
                                    display: 'block',
                                    width: 'auto',
                                    height: '100%'
                                  }} */
                />
              ) : (
                <Image
                  src={`/content/img/avatar/${dataf.avatar}`}
                  alt=""
                  width={144}
                  height={144}
                  layout="fixed"
                />
              )}
            </div>
          </div>
        </a>
        <h5>
          {company.company_name}
        </h5>

        <p className="text-muted text-sm mb-0">
          {/* <i className="fa fa-map-marker text-secondary opacity-4 mr-1" /> */}
          {location}
        </p>
      </Card.Header>
      <Card.Body className="p-4">
        {/*         
        <Media className="align-items-center mb-3">
          <div className="icon-rounded icon-rounded-sm bg-primary-light mr-2">
            <Icon
              icon="diploma-1"
              className="text-primary svg-icon-md"
            />
          </div>
          <Media body>
            <p className="mb-0">235 reviews</p>
          </Media>
        </Media> 
        */}
        {verified &&
          <div className="d-flex align-items-center mb-3">
            <div className={`icon-rounded icon-rounded-sm ${verified ? "bg-primary-light" : "bg-gray-200"} me-2`}>
              <Icon
                icon={verified ? "checkmark-1" : "close-1"}
                className={`${verified ? "text-primary" : "text-muted"} svg-icon-md`}
              />
            </div>
            <div>
              <p className="mb-0">
                {verified ? "Verified" : "Unverified"}
              </p>
            </div>
          </div>
        }
        <Nav
          fill variant="pills"
          className="flex-column ms-1 p-0"
        >
          {sidebarMenu
            .filter((f) => (f.enable))
            .map((item, index) => (
              <ScrollLink
                key={item.label}
                to={item.to}
                {...scrollLinkProps}
              >
                {item.label}
              </ScrollLink>
            ))}
        </Nav>
        <hr />
        <Col className="text-center text-sm-center mb-3">
          <Link href={company.company_website_url || contact.contact_website || '*'} passHref>
            <a target="_blank" rel="nofollow">
              <Button
                variant="outline-primary"
                className="px-3"
              >Visit website
              </Button>
            </a>
          </Link>
        </Col>
        {/* <Col className="text-center text-sm-center">
          <Link href={`/vendor/${code}`} passHref>
            <Button
              color="outline-primary"
              className="px-3"
            >Send request
          </Button>
          </Link>
        </Col> */}

      </Card.Body>
    </Card>
  )
}

export default CardVendor
